import React, { PureComponent } from 'react';
import { compose } from 'redux';
import { RouterProps } from 'react-router';
import { connect } from 'react-redux';
import CharacterSelector from '../components/CharacterLists/CharacterSelector';
import ApplicationIFrame from '../components/ApplicationFrame';
import LoadingScreen from '../components/@common/LoadingScreen/LoadingScreen';
import { remCalc } from '../util/style-util';
import { white } from '../styles/style-constants';
import { Locale, CharacterTypeSectionState, Resource, Workbook } from 'types';
import { selectCharacter, fetchCharacters } from 'state/modules/app';
import { createEvent } from 'api';
import { toggleSlideoutMenu } from 'state/modules/ui/actions';
import withModal from '@lwtears/lwt-common-frontend/lib/Modal/withModal';
import withStyles from 'components/@layout/withStyles';
import { UseModalDispatch, UseModalState } from '@lwtears/lwt-common-frontend/lib/Modal';

type Props = {
  charactersApp: string;
  items: CharacterTypeSectionState[];
  locale: Locale;
  selectedCharacter: Resource;
  showLoadingScreen: boolean;
  currentWorkbook: Workbook;
  selectCharacter: (character: Resource) => void;
  toggleSlideoutMenu: (boolean) => void;
  fetchCharacters: (applicationId: string, locale?: string) => Array<Resource>;
  classes?: any;
} & RouterProps &
  UseModalDispatch &
  UseModalState;

class LetterNumberFormations extends PureComponent<Props> {
  componentDidMount() {
    this.props.fetchCharacters('lnf');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.locale !== this.props.locale) {
      prevProps.fetchCharacters('lnf');
    }
  }

  handleClickItem = async (character: Resource) => {
    await this.props.selectCharacter(character);
    this.openModal();

    createEvent('accessResource', {
      section: 'lnf',
      resourceId: character.id,
      resourceType: character.type.type
    });
  };

  openModal = (): void => {
    const { selectedCharacter } = this.props;
    const {
      title,
      url,
      data: { aspectRatio, heightAdjust }
    } = selectedCharacter;

    this.props.openDraggableModal({
      body: <ApplicationIFrame aspectRatio={aspectRatio} heightAdjust={heightAdjust} url={url} />,
      titleText: title
    });
  };

  render() {
    const {
      charactersApp,
      items,
      locale,
      showLoadingScreen,
      currentWorkbook,
      classes: { container, content }
    } = this.props;

    return (
      <div className={container}>
        <LoadingScreen loading={showLoadingScreen} />
        <div className={content}>
          <CharacterSelector
            items={charactersApp === 'lnf' ? items : []}
            onClickItem={this.handleClickItem}
            application={'LNF'}
            locale={locale}
            currentWorkbook={currentWorkbook}
          />
        </div>
      </div>
    );
  }
}

const styles: any = {
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: white
  },
  content: {
    flex: 1,
    padding: remCalc(26),
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'center'
  }
};

const mapStateToProps = (state: any) => ({
  charactersApp: state.app.app,
  items: state.entity.characterslnf,
  locale: state.app.locale,
  selectedCharacter: state.app.character.selectedCharacter,
  showLoadingScreen: state.app.showLoadingScreen,
  currentWorkbook: state.app.currentWorkbook
});

export default compose<any>(
  withModal,
  withStyles(styles),
  connect(mapStateToProps, {
    selectCharacter,
    toggleSlideoutMenu,
    fetchCharacters
  })
)(LetterNumberFormations);
